import { AlgoRerunDto, BusinessUnit, Consortium, Sample, Series } from '@cambridgeassessment/lib-ee-commons';
import { SampleSearchParams } from '../../store/samplesManagement/types';
import { get as samplerGet } from '../httpHelpers/sampler';
import { get as primerGet } from '../httpHelpers/primer';
import { get as reporterGet } from '../httpHelpers/reporter';
import { post as papiEntreePost, patch as papiEntreePatch } from '../httpHelpers/papiEntree';
import { Entry } from '@cambridgeassessment/lib-ee-commons/src/domain/db/entries';

export const findSample = (searchParams: SampleSearchParams): Promise<Sample> =>
  samplerGet(
    `v1/businessUnit/${searchParams.businessUnit}/samples/series/${
      searchParams.series?.id
    }/assessments/${searchParams.assessmentCode?.toUpperCase()}/components/${
      searchParams.componentNumber
    }/centres/${searchParams.centreId?.toUpperCase()}`,
  );

export const getSampleAlgoHistory = (searchParams: SampleSearchParams): Promise<AlgoRerunDto[]> =>
  samplerGet(
    `v1/businessUnit/${searchParams.businessUnit}/samples/algorithm/series/${
      searchParams.series?.id
    }/assessments/${searchParams.assessmentCode?.toUpperCase()}/components/${
      searchParams.componentNumber
    }/centres/${searchParams.centreId?.toUpperCase()}`,
  );

export const rerunSampleAlgo = (sampleId: string, businessUnit: string, rerunInfo: AlgoRerunDto): Promise<Sample> =>
  papiEntreePost(`v1/businessUnit/${businessUnit}/samples/algorithm`, {
    sampleId,
    rerunInfo,
  });

export const replaceLearner = (
  businessUnit: string,
  learnerIn: Entry,
  learnerOut: Entry,
  sampleId: string,
): Promise<Sample> =>
  papiEntreePost(`v1/businessUnit/${businessUnit}/samples/learner`, {
    learnerIn,
    learnerOut,
    sampleId,
  });

export const getCentreLearners = (businessUnitId: string, sampleId: string): Promise<Entry[]> =>
  samplerGet(`v1/businessUnit/${businessUnitId}/samples/${sampleId}`);

export const getConsortiaInfo = (
  businessUnitId: string,
  seriesId: number,
  centreId: string,
  assessmentCode: string,
  componentNumber: string,
): Promise<Consortium> =>
  primerGet(
    `v1/businessUnit/${businessUnitId}/consortia/centre/${centreId.toUpperCase()}/?seriesId=${seriesId}&assessmentCode=${assessmentCode.toUpperCase()}&componentNumber=${componentNumber}`,
  );

export const updateSample = (
  businessUnitId: string,
  sampleId: string,
  newEntries: Entry[],
  field: keyof Sample,
): Promise<Sample> =>
  papiEntreePatch(`v1/businessUnit/${businessUnitId}/samples/${sampleId}?field=${field}`, { value: newEntries });

export const getSampleReportDownloadLink = (
  businessUnitId: BusinessUnit['id'],
  seriesId: Series['id'],
): Promise<{ downloadUrl: string }> =>
  reporterGet(`v1/${businessUnitId}/series/${seriesId}/sampleReports/sample-report-download-link`);
